module.exports = __webpack_public_path__ + "static/media/dustmite.5659ed2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dustmite.png
// module id = 46
// module chunks = 0